import { DeliveryFileInfo, OutputLocation } from '@ssar-app/domain';
import { Controller, useWatch } from 'react-hook-form';
import {
  FieldErrors,
  Dirtied,
  Control,
  FieldNames,
} from 'react-hook-form/dist/types/form';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
  SimpleGrid,
  Switch,
} from '@chakra-ui/react';

interface DeliveryFileDetailsProps {
  defaultFileName: string;
  label: string;
  propName: string;
  errors?: FieldErrors<DeliveryFileInfo>;
  dirtyFields?: Dirtied<DeliveryFileInfo>;
  onFileSelectionChanged: (outputLocation: OutputLocation) => void;
  touched?: FieldNames<DeliveryFileInfo>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  model?: DeliveryFileInfo;
  clearErrors?: (name?: string | string[] | undefined) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getValues?: any;
}

// const generateFileName = (fileLabel: string): string => {
//   return `P${dayjs().format('YYYYMMDDHHmmss')}_${fileLabel
//     .replace(/\s+/, '_')
//     .replace(/[^a-zA-Z0-9-]/g, '')}`;
// };

export const DeliveryFileDetails = (props: DeliveryFileDetailsProps) => {
  const {
    errors,
    dirtyFields: _dirtyFields,
    touched: _touched,
    control,
    propName,
    label,
    model,
    clearErrors,
    setValue,
    getValues,
  } = props;

  const isNeeded = useWatch({
    control,
    name: `${propName}isNeeded`,
    defaultValue: model?.isNeeded,
  });
  const name = useWatch({
    control,
    name: `${propName}name`,
    defaultValue: model?.name || '',
  });

  return (
    <>
      <SimpleGrid columns={1}>
        <Box>
          <FormControl mb={6} isInvalid={!!errors?.name || !!errors?.isNeeded}>
            <Grid templateColumns='repeat(5,1fr)'>
              <GridItem justifyContent='end' display='flex' h={8}>
                <FormLabel mb={0} display='flex' alignItems='center' mr={2}>
                  {label} :
                </FormLabel>
                <Controller
                  name={`${propName}isNeeded`}
                  control={control}
                  defaultValue={false}
                  render={({ value: _value, onChange }) => {
                    return (
                      <Switch
                        defaultChecked={isNeeded}
                        mt={2}
                        onChange={(e) => {
                          clearErrors && clearErrors('outputFiles');
                          onChange(e);
                          setValue(`${propName}isNeeded`, e.target.checked);
                          setValue(
                            `${propName}name`,
                            e ? props.defaultFileName : '',
                          );
                          control.trigger(`outputFiles`);
                          props.onFileSelectionChanged(getValues());
                        }}
                      />
                    );
                  }}
                ></Controller>
              </GridItem>
              <GridItem colSpan={3}>
                {isNeeded && (
                  <>
                    <Controller
                      name={`${propName}name`}
                      control={control}
                      defaultValue={name}
                      render={({ value, onChange }) => (
                        <Input
                          value={value}
                          onChange={(e) => {
                            onChange(e);
                            setValue(`${propName}name`, e.target.value);
                            props.onFileSelectionChanged(getValues());
                          }}
                          width={'md'}
                          ml={5}
                          spellCheck={false}
                        />
                      )}
                    ></Controller>
                    <FormErrorMessage ml={5}>
                      {errors?.name?.message}
                    </FormErrorMessage>
                  </>
                )}
              </GridItem>
            </Grid>
          </FormControl>
        </Box>
      </SimpleGrid>
    </>
  );
};
